import { Flex } from '@coolblue-development/freddy';
import { PropertyGroup } from '@features/product/typings';
import { useDebouncedValue } from '@hooks/useDebouncedValue';

import PropertiesTable from '../PropertiesTable';
import countTotalProperties from '../utils/count-total-properties';
import filterSpecifications from '../utils/filter-specifications';
import mergePropertyGroups from '../utils/merge-property-groups';
import { useSpecificationsSearch } from './SearchContext';

type Props = {
  productId: number;
  productTypeId: number;
  propertyGroups: PropertyGroup[];
};

export default function SearchResult({ productId, productTypeId, propertyGroups }: Props) {
  const { queries } = useSpecificationsSearch();
  const deferredQuery = useDebouncedValue(queries.get(productId) ?? '', 500);
  const result = filterSpecifications(deferredQuery, propertyGroups);

  return (
    <Flex direction='column' gap={400}>
      {deferredQuery.trim().length > 0 && countTotalProperties(result) <= 10 ? (
        <PropertiesTable
          properties={mergePropertyGroups(result).properties}
          productTypeId={productTypeId}
          variant='base'
        />
      ) : (
        result.map(propertyGroup => (
          <PropertiesTable
            key={propertyGroup.title}
            title={propertyGroup.title}
            properties={propertyGroup.properties}
            productTypeId={productTypeId}
          />
        ))
      )}
    </Flex>
  );
}
